import { Link } from "react-router-dom";
import StoreBadges from "./StoreBadges";

const buttonBase =
    "inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full text-sm sm:text-base font-semibold whitespace-nowrap transition-colors";

export default function AppDownloadButtons({
    variant = "dark",
    showDirectory = false,
    className = "",
}) {
    const isDark = variant === "dark";

    const secondaryClass = isDark
        ? "border border-white/25 bg-white/8 text-white hover:bg-white/12"
        : "border border-slate-200 bg-white text-foreground hover:bg-slate-50";

    return (
        <div className={`flex flex-col items-center gap-4 ${className}`}>
            <StoreBadges size="large" />
            {showDirectory && (
                <Link
                    to="/directory"
                    data-testid="final-cta-directory-button"
                    className={`${buttonBase} ${secondaryClass}`}
                >
                    Browse Directory
                </Link>
            )}
        </div>
    );
}
